import React from 'react';
import Remarkable from 'remarkable'
import * as FormFields from "components/forms/FormFields"
import ErrorMessages from "components/general/ErrorMessages"
import * as ProfileActions from "actions/ProfileActions"
import { IconButton } from 'components/general/IconButton'
import * as Icons from 'react-bootstrap-icons';
import * as Dto from "actions/Dto";

//import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

enum EditTypes {
    ADD = "add-experience",
    EDIT = "edit-experience"
}

interface ExperiencesState {
	experiences: Dto.ExperienceDto[]
	uncollapsed: number|null
	add: Dto.ExperienceDto|null
	edit: Dto.ExperienceDto|null
	editId?: number|null
	wizard: boolean
	editType: EditTypes|null
	errors: Dto.ErrorDto[]|null
	messages: Dto.MessageDto[]|null
}

interface ExperiencesProps {
	accountId: number
	profile: Dto.ProfileDto
	onUpdated: (profile: Dto.Profile) => void
}

export default class Experiences extends React.Component<ExperiencesProps, ExperiencesState> {

	constructor(props: ExperiencesProps) {
		super(props);
		this.state = {experiences: props.profile.experiences, uncollapsed: null,
			add: {} as Dto.ExperienceDto, edit: null, wizard: false, editType: null,
			errors: null, messages: null
		}
	}

	componentWillReceiveProps(nextProps, nextState){
		this.setState({experiences: nextProps.profile.experiences, wizard: (nextProps.wizard ? nextProps.wizard : false), editType:  (nextProps.editType ? nextProps.editType : null)});
	}

	handleChange(event) {

		console.log("handleChange", event);

		if (this.state.edit == null) return;

		var value = (event.target.value ? event.target.value : "");
		value = value.replace(/•/g, "-");	//replace bullets with markdown
		value = value.replace(//g, "-");	//replace bullets with markdown
		value = value.replace(/-\t/g, "- ");	//replace bullets-tab with bullet-space

		var edit = this.state.edit;
		edit[event.target.name] = value;

		this.setState({edit: edit});


	}

	handleCheckboxChange(event) {

		if (this.state.edit == null) return;

		var edit = this.state.edit;
		edit[event.target.name] = event.target.checked;
		this.setState({edit: edit});

	}

	handleSubmit(event) {
		this.setState({errors: null});
		ProfileActions.experienceUpdate(this.props.accountId, this.props.profile.id, this.state.edit,
			(profile) => {
				this.setState({add: {} as Dto.ExperienceDto, edit: null, editId: null, editType: null});
				this.props.onUpdated(profile);
			},
			(errors) => this.setState({errors: errors})
		);
	}

	handleAddChange(event) {
		var add: any = this.state.add;
		add[event.target.name] = event.target.value;
		this.setState({add: add});
	}

	handleAddSubmit(event) {

		ProfileActions.experienceAdd(this.props.accountId, this.props.profile.id, this.state.add,
			(profile) => {
				this.setState({add: {} as Dto.ExperienceDto, errors: null, editType: null});
				this.props.onUpdated(profile);
			},
			(errors) => this.setState({errors: errors})
		);

	}

	edit(experience) {
		const cloneExperience = {...experience}
		this.setState({edit: cloneExperience, editType: EditTypes.EDIT});
	}

	unedit() {
		this.setState({edit: null, editType: null});
	}

	uncollapse(id) {
		this.setState({uncollapsed: id});
	}

	add() {
		this.setState({add: {} as Dto.ExperienceDto, editType: EditTypes.ADD});
	}

	unadd() {
		this.setState({add: {} as Dto.ExperienceDto, editType: null});
	}

	delete(experience) {
		if (window.confirm('Delete experience?')) {
			ProfileActions.experienceDelete(this.props.accountId, this.props.profile.id, experience.id,
				(profile) => this.props.onUpdated(profile),
				(errors) => this.setState({errors: errors})
			);
		}
	}

	demote(experience) {
		ProfileActions.experienceDemote(this.props.accountId, this.props.profile.id, experience.id,
			(profile) => this.props.onUpdated(profile),
			(errors) => this.setState({errors: errors})
		);
	}

	promote(experience) {
		ProfileActions.experiencePromote(this.props.accountId, this.props.profile.id, experience.id,
			(profile) => this.props.onUpdated(profile),
			(errors) => this.setState({errors: errors})
		);
	}

	toggleShowHide(experience) {
		ProfileActions.experienceShowHide(this.props.accountId, this.props.profile.id, experience.id,
			(profile) => this.props.onUpdated(profile),
			(errors) => this.setState({errors: errors})
		);
	}

	renderExperience() {

		return this.state.experiences.map((experience) => {
			var md = new Remarkable();

			return (

				<div key={"experience" + experience.id} className="">
					<div className={" experience" + (experience.hidden ? " experience-hidden" : "") + (experience.breakAfter ? " break-after" : "")}>
						<h3>{experience.organisation}</h3><h4>{experience.title}</h4>
						<h5>{experience.location}</h5>
						<div className="experience-date">{experience.startDate} to {experience.endDate != null ? experience.endDate : "Current"}</div>
						<div>
								{ experience.featureImageUrl ? <img src={experience.featureImageUrl} className="feature-image" /> : null }
						<div className={this.state.uncollapsed === experience.id ? "description" : "description collapsed"} dangerouslySetInnerHTML={{ __html: md.render(experience.description)}} />
						</div>
						<div>
							{this.state.uncollapsed !== experience.id ? <button onClick={(e) => this.uncollapse(experience.id)}>More...</button> : null}
						</div>
						<div className="controls">
							<IconButton title="Edit" onClick={() => this.edit(experience)} icon={<Icons.Pencil />}  />
							<IconButton title="Delete" className="delete-link" onClick={() => this.delete(experience)} icon={<Icons.Trash />}  />
							{ experience.hidden ?
								<IconButton title="Hide" className="hide-link" onClick={() => this.toggleShowHide(experience)} icon={<Icons.EyeSlash />}  /> :
								<IconButton title="Hide" className="hide-link" onClick={() => this.toggleShowHide(experience)} icon={<Icons.Eye />}  />
							}
							<IconButton title="Demote" className="hide-link" onClick={() => this.demote(experience)} icon={<Icons.ChevronDown />}  />
							<IconButton title="Promote" className="hide-link" onClick={() => this.promote(experience)} icon={<Icons.ChevronUp />}  />

						</div>
					</div>
					{this.state.edit !== null && this.state.edit.id === experience.id ? this.renderEdit() : null}
				</div>

			);

		});
	}

	renderEdit() {

		if (!this.state.edit) return null;

		return (

			<FormFields.Model title="Edit Experience" isOpen={this.state.editType !== null && this.state.editType === EditTypes.EDIT} 
				onHide={(e) => this.unedit()}
			 	className="modal-lg" onConfirm={(e) => this.handleSubmit(e)} onCancel={(e) => this.unedit()}>

				<FormFields.Text name="organisation" title="Organisation" placeholder="Organisation" mandatory={true} value={this.state.edit.organisation} onChange={(e) => this.handleChange(e)} />
				<FormFields.Text name="title" title="Title" placeholder="Title" mandatory={true} value={this.state.edit.title} onChange={(e) => this.handleChange(e)} />

				<div className="row">
					<div className="col">
						<FormFields.DateMonthYear name="startDate" title="Start Date" value={this.state.edit.startDate} mandatory={true} onChange={(e) => this.handleChange(e)} />
					</div>
					<div className="col">
						<FormFields.DateMonthYear name="endDate" title="End Date" allowCurrent={true} value={this.state.edit.endDate} onChange={(e) => this.handleChange(e)} />
					</div>
				</div>

				<FormFields.TextArea name="description" title="Description" placeholder="Full description of your experience" mandatory={true} value={this.state.edit.description} rows={6} onChange={(e) => this.handleChange(e)} helpText={<small>Use markdown to add formatting. See <a href="https://en.wikipedia.org/wiki/Markdown" target="_blank" rel="noopener noreferrer">here</a> for help on markdown.</small>} />
				<FormFields.TextArea name="summary" title="Summary" placeholder="Short form summary of your experience" value={this.state.edit.summary} rows={3} onChange={(e) => this.handleChange(e)} helpText={<small>Use markdown to add formatting. See <a href="https://en.wikipedia.org/wiki/Markdown" target="_blank" rel="noopener noreferrer">here</a> for help on markdown.</small>} />

				<FormFields.Text name="location" title="Location" value={this.state.edit.location} onChange={(e) => this.handleChange(e)} />
				<FormFields.Text name="featureImageUrl" title="Feature Image URL" value={this.state.edit.featureImageUrl} onChange={(e) => this.handleChange(e)} placeholder="https://talentedteam.com/featureimage.jpg" helpText="A link to a publically accessible image."/>

				<FormFields.Checkbox name="breakAfter" title="Break After"
					value={this.state.edit.breakAfter} inline
					onChange={(e) => this.handleCheckboxChange(e)}
				/>

			</FormFields.Model>

		);

	}

	renderAdd() {

		if(!this.state.add) return null;

		return (

			<FormFields.Model title="Add Experience" isOpen={this.state.editType !== null && this.state.editType === EditTypes.ADD} onHide={(e) => this.unadd()}
				className="modal-lg" onConfirm={(e) => this.handleAddSubmit(e)} onCancel={(e) => this.unadd()}>

				<FormFields.Text name="organisation" title="Organisation" placeholder="Organisation" mandatory={true} value={this.state.add.organisation} onChange={(e) => this.handleAddChange(e)} />
				<FormFields.Text name="title" title="Title" placeholder="Title" mandatory={true} value={this.state.add.title} onChange={(e) => this.handleAddChange(e)} />

				<div className="row">

					<div className="col">
						<FormFields.DateMonthYear name="startDate" title="Start Date" allowCurrent={true} mandatory={true} value={this.state.add.startDate} onChange={(e) => this.handleAddChange(e)} />
					</div>
					<div className="col">
						<FormFields.DateMonthYear name="endDate" title="End Date" allowCurrent={true} mandatory={true} value={this.state.add.endDate} onChange={(e) => this.handleAddChange(e)} />

					</div>
				</div>

				<FormFields.TextArea name="description" title="Description" placeholder="Full description of your experience" mandatory={true} value={this.state.add.description} rows={6} onChange={(e) => this.handleAddChange(e)} helpText={<small>Use markdown to add formatting. See <a href="https://en.wikipedia.org/wiki/Markdown" target="_blank" rel="noopener noreferrer">here</a> for help on markdown.</small>} />
				<FormFields.TextArea name="summary" title="Summary" placeholder="Short form summary of your experience" value={this.state.add.summary} rows={3} onChange={(e) => this.handleAddChange(e)} helpText={<small>Use markdown to add formatting. See <a href="https://en.wikipedia.org/wiki/Markdown" target="_blank" rel="noopener noreferrer">here</a> for help on markdown.</small>} />

				<FormFields.Text name="location" title="Location" value={this.state.add.location} onChange={(e) => this.handleAddChange(e)} />

			</FormFields.Model>
		);
	}

	render() {

		return (
			<React.Fragment>

				<div className="profile-tile">



					<h2>Experience</h2>
					<div className="controls"><IconButton icon={<Icons.PlusLg />} onClick={() => this.add()} /></div>

					<ErrorMessages errors={this.state.errors} component={this}/>

					{this.renderExperience()}

					{this.renderAdd()}

				</div>
			</React.Fragment>
		);
	}

}